import { useMemo } from 'react';
import {
  type TOrganizationNodeDrawer,
  selectLeafNodes,
} from 'slices/organizationHierarchy.slice';
import { useAppSelector } from 'slices/store';
import { TEDrawerSection } from '@timeedit/ui-components';
import { ObjectsCard } from '../components/objectsCard';

type AffiliatedDataSectionProps = {
  data: TOrganizationNodeDrawer;
};

export const AffiliatedData = ({ data }: AffiliatedDataSectionProps) => {
  const leafNodes = useAppSelector(selectLeafNodes);

  const isLeaf = useMemo(() => {
    return leafNodes.some((node) => node === data?.id);
  }, [leafNodes, data]);

  return (
    isLeaf && (
      <TEDrawerSection label="Affiliated data">
        <ObjectsCard data={data} />
      </TEDrawerSection>
    )
  );
};
